import storage from './storage'

const DeviceKey = 'SNTCloudDevice';
export default {

    device: storage.get(DeviceKey),
    
    setDevice(result){
        this.device = result;
        storage.set(DeviceKey, result);
    },

    clear(){
        storage.remove(DeviceKey);
        this.device = null;
    }

}